import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const LoadingFallback = () => {
  const { t } = useTranslation();
  
  return (
    <div className="flex h-screen w-full items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden="true" />
        <span className="text-sm text-muted-foreground">{t('common.loading')}</span>
      </div>
    </div>
  );
};
